export default "__VITE_ASSET__FBXNs02I__"